import { graphql } from 'gatsby'

// eslint-disable-next-line no-restricted-exports
export { default } from './Post'

export const query = graphql`
  query ($slug: String!) {
    ghostPost(slug: { eq: $slug }) {
      ...GhostPostFields
    }
    allGhostPost(
      filter: { slug: { ne: $slug } }
      sort: { published_at: DESC }
      limit: 5
    ) {
      nodes {
        ...GhostPostFields
      }
    }
  }
`
